// Module
var code = " <div class=\"show-hide-toggle\" data-test-id=\"show_advanced_settings_btn\"> <h4> <label> <input type=\"checkbox\" class=\"filled-in\"/><span></span> <span id=\"checkbox-label\"></span> </label> </h4> </div> <label id=\"description\"></label> ";
// Exports
export default code;